/**
 * The shift schedule. Bullworth's class timetable, with a punch clock.
 *
 * Every field here is the kind of thing that gets argued about in a real
 * banquets department, which is why it is data:
 *
 *   - `grace` is how many minutes past the start still counts as on time. Five
 *     is generous by hotel standards and correct by game standards.
 *   - `lateWindow` is how long the department waits before it stops calling you
 *     late and starts calling you a no-show. Past it you are written up whether
 *     you turn up or not.
 *   - `openEarly` is how long before the start the clock will accept a punch.
 *     Without it you can punch in at nine in the morning for a two o'clock
 *     shift and be paid for lunch.
 */

export const SHIFTS = {
  'pm-banquet': {
    id: 'pm-banquet',
    name: 'PM Banquet',
    department: 'banquets',
    start: '14:00',
    end: '22:00',
    grace: 5,
    lateWindow: 60,
    openEarly: 60,
  },
  'am-banquet': {
    id: 'am-banquet',
    name: 'AM Banquet',
    department: 'banquets',
    start: '06:00',
    end: '14:00',
    grace: 5,
    lateWindow: 60,
    openEarly: 60,
  },
  'double-banquet': {
    id: 'double-banquet',
    name: 'Double',
    department: 'banquets',
    start: '10:00',
    end: '23:00',
    grace: 5,
    lateWindow: 45,
    openEarly: 45,
  },
};

/**
 * Which shift each day of the week is, starting Monday.
 *
 * No days off in the slice. A day off is a day with no shift to clock into and
 * no BEO to run, which is a day with no game in it — worth having once there is
 * something to do off the clock, and not before.
 */
export const WEEK = [
  'pm-banquet',
  'pm-banquet',
  'am-banquet',
  'pm-banquet',
  'double-banquet',
  'double-banquet',
  'am-banquet',
];

/** The shift for a day number, 1-based, wrapping every week. */
export function shiftForDay(day) {
  return SHIFTS[WEEK[(day - 1) % WEEK.length]];
}
